import * as PIXI from "pixi.js";
import {pixiComponents} from "../../index";
import {socketService} from "../../socketService";
import {gsap} from "gsap";
import {store} from "../../store";
import {t, TKeys} from "../../translationService";
import {hideInfoSection} from "../../infoSection";
import {hideHistorySection} from "../../historySection";
import {hideReconnectingModal} from "../reconnectingModal/reconnectingModal";
import {hideConnectionLostModal} from "../connectionLostModal/connectionLostModal";

let lastSpinBtnAnimAnionDelay = 0;
let lastActivityDelay = 0;
let previousTimestamp = 0;

const setDelaysInitial = () => {
    lastSpinBtnAnimAnionDelay = 0;
    lastActivityDelay = 0;
}

window.addEventListener("touchstart", setDelaysInitial);
window.addEventListener("click", setDelaysInitial);
window.addEventListener('keyup', setDelaysInitial);

const detectActivity = (timestamp) => {
    const deltaTime = timestamp - previousTimestamp;
    lastActivityDelay += deltaTime;
    previousTimestamp = timestamp;
    lastSpinBtnAnimAnionDelay += deltaTime;

    if(lastSpinBtnAnimAnionDelay>10000){
        spinBtnRotateAnimation();
        lastSpinBtnAnimAnionDelay = 0;
    }

    if (store.sessionDurationSeconds < lastActivityDelay / 1000) {
        store.setIsSessionExpired(true);
        const sessionExpiredComponent = createSessionExpiredNotification();
        pixiComponents.app.stage.addChild(sessionExpiredComponent);
        pixiComponents.sessionExpiredComponent = sessionExpiredComponent;
        socketService.stopConnection();
        hideHistorySection();
        hideInfoSection();
        hideReconnectingModal();
        hideConnectionLostModal();
        return;
    }
    requestAnimationFrame(detectActivity);
}

requestAnimationFrame(detectActivity);

const createSessionExpiredNotification = () => {
    const blackFullScreen = new PIXI.Graphics();
    blackFullScreen.beginFill(0x000000);
    blackFullScreen.drawRect(0, 0, 1500, 1500);
    blackFullScreen.endFill();

    const text = new PIXI.Text(t(TKeys.SESSION_EXPIRED), textStyle);
    text.anchor.set(0.5);
    text.x = pixiComponents.app.screen.width / 2;
    text.y = pixiComponents.app.screen.height / 2;

    const container = new PIXI.Container();
    container.addChild(blackFullScreen, text);

    return container;
}

const textStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fontSize: 40,
    fill: 0xffffff,
    wordWrapWidth: 440
});

const spinBtnRotateAnimation = () => {
    if(!pixiComponents.cpItems.spinBtn){
        return;
    }

    gsap.to(pixiComponents.cpItems.spinBtn, {
        rotation: 1.2,
        duration: 0.6
    }).then(() => {
            gsap.to(pixiComponents.cpItems.spinBtn, {
                rotation: 0,
                duration: 1,
                ease: "elastic",
            })
        }
    )
}